import { render, staticRenderFns } from "./QualifiedSignatureLoadPluginModal.vue?vue&type=template&id=5820a33f&lang=pug"
import script from "./QualifiedSignatureLoadPluginModal.vue?vue&type=script&lang=js"
export * from "./QualifiedSignatureLoadPluginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports